/**
 * @param {StoreState} state
 *
 * @returns {StoreAppState}
 */
export const selectApp = (state) => state.app;



// WEBPACK FOOTER //
// ./src/modules/app/selectors/index.js